// Fake data for the application

export const fakeJobSeekers = [
  {
    id: 'js1',
    userId: 'user1',
    name: 'John Doe',
    email: 'john.doe@example.com',
    phone: '+1234567890',
    location: 'New York, NY',
    profileImage: 'https://via.placeholder.com/150',
    title: 'Senior Software Engineer',
    experience: '5 years',
    skills: ['React', 'Node.js', 'Python', 'AWS', 'Docker'],
    education: 'BS Computer Science - MIT',
    resume: 'https://example.com/resume.pdf',
    bio: 'Passionate software engineer with 5 years of experience in full-stack development.',
    expectedSalary: '$120,000 - $150,000',
    availability: 'Immediately',
    role: 'jobseeker'
  },
  {
    id: 'js2',
    userId: 'user2',
    name: 'Jane Smith',
    email: 'jane.smith@example.com',
    phone: '+1234567891',
    location: 'San Francisco, CA',
    profileImage: 'https://via.placeholder.com/150',
    title: 'UX/UI Designer',
    experience: '3 years',
    skills: ['Figma', 'Adobe XD', 'Sketch', 'Prototyping', 'User Research'],
    education: 'BA Design - Stanford University',
    resume: 'https://example.com/resume2.pdf',
    bio: 'Creative designer focused on user-centered design and accessibility.',
    expectedSalary: '$90,000 - $110,000',
    availability: '2 weeks notice',
    role: 'jobseeker'
  },
  {
    id: 'js3',
    userId: 'user3',
    name: 'Mike Johnson',
    email: 'mike.j@example.com',
    phone: '+1234567892',
    location: 'Austin, TX',
    profileImage: 'https://via.placeholder.com/150',
    title: 'Data Scientist',
    experience: '4 years',
    skills: ['Python', 'Machine Learning', 'TensorFlow', 'SQL', 'Data Visualization'],
    education: 'MS Data Science - UC Berkeley',
    resume: 'https://example.com/resume3.pdf',
    bio: 'Data scientist specializing in predictive modeling and ML algorithms.',
    expectedSalary: '$110,000 - $140,000',
    availability: '1 month notice',
    role: 'jobseeker'
  }
];

export const fakeEmployers = [
  {
    id: 'emp1',
    userId: 'employer1',
    name: 'Sarah Williams',
    email: 'sarah@techcorp.com',
    phone: '+1234567893',
    position: 'HR Manager',
    companyId: 'comp1',
    profileImage: 'https://via.placeholder.com/150',
    role: 'employer'
  },
  {
    id: 'emp2',
    userId: 'employer2',
    name: 'David Brown',
    email: 'david@innovate.com',
    phone: '+1234567894',
    position: 'Talent Acquisition Lead',
    companyId: 'comp2',
    profileImage: 'https://via.placeholder.com/150',
    role: 'employer'
  }
];

export const fakeCompanies = [
  {
    id: 'comp1',
    name: 'TechCorp Solutions',
    industry: 'Technology',
    size: '500-1000 employees',
    location: 'New York, NY',
    website: 'https://techcorp.example.com',
    logo: 'https://via.placeholder.com/200',
    description: 'Leading technology company specializing in enterprise software solutions.',
    founded: '2010',
    benefits: ['Health Insurance', '401K', 'Remote Work', 'Unlimited PTO'],
    culture: 'Innovation-driven, collaborative, and fast-paced environment.',
    openPositions: 15
  },
  {
    id: 'comp2',
    name: 'Innovate Labs',
    industry: 'Software Development',
    size: '100-500 employees',
    location: 'San Francisco, CA',
    website: 'https://innovatelabs.example.com',
    logo: 'https://via.placeholder.com/200',
    description: 'Startup focused on AI and machine learning innovations.',
    founded: '2018',
    benefits: ['Equity Options', 'Health Insurance', 'Flexible Hours', 'Learning Budget'],
    culture: 'Startup culture with focus on innovation and personal growth.',
    openPositions: 8
  },
  {
    id: 'comp3',
    name: 'Design Studio Pro',
    industry: 'Design & Creative',
    size: '50-100 employees',
    location: 'Los Angeles, CA',
    website: 'https://designstudio.example.com',
    logo: 'https://via.placeholder.com/200',
    description: 'Award-winning design studio creating beautiful digital experiences.',
    founded: '2015',
    benefits: ['Health Insurance', 'Creative Freedom', 'Remote Options', 'Team Events'],
    culture: 'Creative, collaborative, and design-focused environment.',
    openPositions: 5
  }
];

export const fakeJobs = [
  {
    id: 'job1',
    companyId: 'comp1',
    title: 'Senior React Developer',
    type: 'Full-time',
    location: 'New York, NY',
    salary: '$130,000 - $160,000',
    description: 'We are looking for an experienced React developer to join our team.',
    requirements: ['5+ years React experience', 'Strong JavaScript skills', 'Team player'],
    posted: '2024-01-15',
    deadline: '2024-02-15'
  },
  {
    id: 'job2',
    companyId: 'comp2',
    title: 'Machine Learning Engineer',
    type: 'Full-time',
    location: 'San Francisco, CA',
    salary: '$140,000 - $180,000',
    description: 'Join our AI team to build cutting-edge ML models.',
    requirements: ['MS in CS or related field', 'Python/TensorFlow', '3+ years ML experience'],
    posted: '2024-01-20',
    deadline: '2024-02-28'
  }
];

export const fakeReviews = [
  {
    id: 'rev1',
    reviewerId: 'emp1',
    reviewerName: 'Sarah Williams',
    reviewerRole: 'employer',
    targetId: 'js1',
    targetName: 'John Doe',
    targetType: 'candidate',
    rating: 5,
    comment: 'Excellent candidate! Strong technical skills and great communication.',
    date: '2024-01-10',
    helpful: 12
  },
  {
    id: 'rev2',
    reviewerId: 'js2',
    reviewerName: 'Jane Smith',
    reviewerRole: 'jobseeker',
    targetId: 'comp1',
    targetName: 'TechCorp Solutions',
    targetType: 'company',
    rating: 4,
    comment: 'Great company culture and benefits. Interview process was smooth.',
    date: '2024-01-12',
    helpful: 8
  },
  {
    id: 'rev3',
    reviewerId: 'emp2',
    reviewerName: 'David Brown',
    reviewerRole: 'employer',
    targetId: 'js3',
    targetName: 'Mike Johnson',
    targetType: 'candidate',
    rating: 5,
    comment: 'Outstanding data science skills. Would definitely recommend.',
    date: '2024-01-14',
    helpful: 15
  }
];

export const fakeAIMatches = [
  {
    id: 'match1',
    jobSeekerId: 'js1',
    jobSeekerName: 'John Doe',
    companyId: 'comp1',
    companyName: 'TechCorp Solutions',
    jobId: 'job1',
    jobTitle: 'Senior React Developer',
    matchScore: 92,
    explanation: {
      skillsMatch: {
        score: 95,
        details: 'Your React and Node.js skills perfectly align with the job requirements. Strong match in AWS and Docker as well.'
      },
      experienceMatch: {
        score: 90,
        details: 'Your 5 years of experience meets the senior-level requirement. Your background in full-stack development is highly relevant.'
      },
      cultureMatch: {
        score: 88,
        details: 'Based on your profile and company culture, there is a strong alignment in innovation and collaborative work style.'
      },
      salaryMatch: {
        score: 95,
        details: 'Your expected salary range ($120K-$150K) aligns well with the offered range ($130K-$160K).'
      },
      locationMatch: {
        score: 100,
        details: 'Perfect match! Both you and the company are located in New York, NY.'
      },
      strengths: [
        'Perfect technical skills match for React and modern web technologies',
        'Strong experience level matching senior position requirements',
        'Excellent salary range alignment',
        'Same location - no relocation needed'
      ],
      considerations: [
        'Company culture emphasizes fast-paced environment - ensure this matches your work style',
        'Position may require occasional travel'
      ]
    },
    date: '2024-01-15'
  },
  {
    id: 'match2',
    jobSeekerId: 'js3',
    jobSeekerName: 'Mike Johnson',
    companyId: 'comp2',
    companyName: 'Innovate Labs',
    jobId: 'job2',
    jobTitle: 'Machine Learning Engineer',
    matchScore: 88,
    explanation: {
      skillsMatch: {
        score: 90,
        details: 'Strong match in Python, Machine Learning, and TensorFlow. Your data science background aligns well with ML engineering role.'
      },
      experienceMatch: {
        score: 85,
        details: 'Your 4 years of experience is solid, though position prefers 5+ years. Your MS degree compensates well.'
      },
      cultureMatch: {
        score: 92,
        details: 'Excellent fit! Startup culture matches well with your innovative mindset and desire for growth.'
      },
      salaryMatch: {
        score: 87,
        details: 'Your range ($110K-$140K) is slightly below the offered range ($140K-$180K), which works in your favor.'
      },
      locationMatch: {
        score: 75,
        details: 'You are in Austin, TX while position is in San Francisco, CA. Remote options may be available.'
      },
      strengths: [
        'Excellent technical skills for ML engineering role',
        'MS degree meets educational requirements',
        'Strong cultural fit with startup environment',
        'Salary range provides room for negotiation'
      ],
      considerations: [
        'Location mismatch - may need to relocate or negotiate remote work',
        'Experience is slightly below preferred level but compensated by education',
        'Fast-paced startup environment requires adaptability'
      ]
    },
    date: '2024-01-16'
  }
];

export const fakeApplications = [
  {
    id: 'app1',
    jobSeekerId: 'js1',
    jobId: 'job1',
    companyId: 'comp1',
    status: 'under_review',
    appliedDate: '2024-01-15',
    notes: 'Strong candidate, scheduling interview'
  },
  {
    id: 'app2',
    jobSeekerId: 'js3',
    jobId: 'job2',
    companyId: 'comp2',
    status: 'interview_scheduled',
    appliedDate: '2024-01-16',
    interviewDate: '2024-01-25',
    notes: 'Phone screen completed, technical interview next'
  }
];
